import React, { useState, useEffect, useRef } from "react";
import {
  ChevronDoubleDownIcon,
  CalculatorIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import CalcuImage from "../../assets/images/mobileimage.webp";
// import CalcuImage from '../../assets/images/mobileimage_1.png';
import CustomDropdown from "../sharedComponents/customDropDown";
import CustomInput from "../sharedComponents/customInput";
import CustomButton from "../sharedComponents/customButton";
import CustomTitle from "../sharedComponents/customTitle";
import { useDispatch, useSelector } from "react-redux";
import { checkShipmentCost } from "../../redux/reducer/shipmentCostReducer";
import { useTranslation } from "react-i18next";
import BoxSection7 from "../../assets/images/BoxSection7.webp";
import CustomDropdownCountry from "../sharedComponents/CustomDropdownCountry";
import ShippingCompanies from "./ShippingCompanies";
import CustomCheckBox from "../sharedComponents/customCheckBox";
import {
  getMenuItemsLocationFrom,
  getMenuItemsLocationTo,
} from "../../constent/countries";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
const CalcalateShippingSection = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [inputWeight, setInputWeight] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [height, setHeight] = useState(1);
  const [width, setWidth] = useState(1);
  const [length, setLength] = useState(1);

  const [selectedFrom, setSelectedFrom] = useState(null);
  const [selectedTo, setSelectedTo] = useState(null);

  const { loading = false, error = null } = useSelector(
    (state) => state.shipment || {}
  );
  const [hasDimensions, setHasDimensions] = useState(false); // State for dimensions checkbox
  const [errorMessage, setErrorMessage] = useState("");
  const [resultText, setResultText] = useState("");

  const popUpRef = useRef(null);
  const buttonRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const menuItemsLocationFrom = getMenuItemsLocationFrom(t);
  const menuItemsLocationTo = getMenuItemsLocationTo(t);
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();
  const sortedLocations = [...menuItemsLocationTo].sort((a, b) =>
    a.name.localeCompare(b.name, i18n.language === "ar" ? "ar" : "en", {
      sensitivity: "base",
    })
  );

  // console.log(inputWeight)
  // console.log(selectedTo)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popUpRef.current &&
        !popUpRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleCheckPrice = async () => {
    let weight = parseFloat(inputWeight);

    if (!selectedTo) {
      setErrorMessage(true);
      setResultText("");
      return;
    } else if (!selectedFrom) {
      setErrorMessage(true);
      setResultText("");
      return;
    }

    // if (weight > 30) {
    //   weight = 31;
    // }
    else {
      const integerPart = Math.floor(weight);
      const decimalPart = weight - integerPart;

      if (decimalPart <= 0.25) {
        weight = integerPart;
      } else if (decimalPart <= 0.75) {
        weight = integerPart + 0.5;
      } else {
        weight = integerPart + 1;
      }
    }

    setErrorMessage(""); // Clear previous error

    const shipmentData = {
      weight: weight || null,
      zone: selectedFrom,
      country: i18n.getResource("en", "translation", `countries.${selectedTo}`),
      length: hasDimensions
        ? parseFloat(length)
          ? parseFloat(length)
          : 1
        : null,
      height: hasDimensions
        ? parseFloat(height)
          ? parseFloat(height)
          : 1
        : null,
      width: hasDimensions ? (parseFloat(width) ? parseFloat(width) : 1) : null,
      count: hasDimensions
        ? parseFloat(quantity)
          ? parseFloat(quantity)
          : 1
        : null,
    };
    // console.log(shipmentData)
    const result = await dispatch(checkShipmentCost(shipmentData));
    if (result?.payload) {
      setResultText(result.payload);
      setIsOpen(!isOpen);
    } else {
      setResultText("");
    }
  };

  const closeModal = () => {
    setResultText(null);
    setIsOpen(false);
  };

  const convertArabicToEnglishNumbers = (value) => {
    return value.replace(/[٠-٩]/g, (digit) => "٠١٢٣٤٥٦٧٨٩".indexOf(digit));
  };
  // console.log(resultText)
  return (
    <div className="relative" dir={direction}>
      <img
        src={BoxSection7}
        alt="Background"
        className="absolute right-0 hidden transform -translate-y-1/2 sm:block top-1/2 w-14 md:w-20 "
      />

      <div className="relative pt-5 max-container" ref={buttonRef}>
        <CustomTitle title={t("calculateShippingSection.title")} />
        <div className="items-center justify-center md:flex">
          <div className="flex items-center justify-center w-full md:w-1/2">
            <img
              src={CalcuImage}
              alt="Shipping"
              className="object-cover w-full mb-4"
            />
          </div>

          <div className="flex-col w-full p-4 md:w-1/2">
            <CustomDropdown
              title={t("calculateShippingSection.shippingFrom")}
              menuItems={menuItemsLocationFrom}
              textColor="custom-gray"
              onSelect={(item) => setSelectedFrom(item.id)}
              selected={selectedFrom}
              flag={true}
            />
            {!selectedFrom && errorMessage && (
              <p className="mb-2 text-red-500">{t("invalidSelectedTo")}</p>
            )}

            <CustomDropdownCountry
              title={t("calculateShippingSection.shippingTo")}
              menuItems={sortedLocations}
              textColor="custom-gray"
              onSelect={(item) => setSelectedTo(item.id)}
              selected={selectedTo}
            />
            {!selectedTo && errorMessage && (
              <p className="mb-2 text-red-500">{t("invalidSelectedFrom")}</p>
            )}

            <CustomInput
              type="number"
              title={t("calculateShippingSection.enterWeight")}
              placeholder={t("calculateShippingSection.enterText")}
              textColor="gray-800"
              value={inputWeight}
              onChange={(e) =>
                setInputWeight(convertArabicToEnglishNumbers(e.target.value))
              }
            />
            {/* {!inputWeight && errorMessage && <p className="my-2 text-red-500">{t("invalidWeight")}</p>} */}

            <CustomCheckBox
              title={t("EnterDimensions")}
              onChange={() => setHasDimensions(!hasDimensions)}
              isChecked={hasDimensions}
            />

            {hasDimensions && (
              <div className="flex flex-col gap-2 mt-4 " dir={direction}>
                {/* Quantity and Weight */}
                <div className="flex justify-between w-full">
                  <div className="flex flex-col w-[48%]">
                    <label className="mb-2 text-black" htmlFor="quantity">
                      {t("quantity")}
                    </label>
                    <input
                      type="number"
                      id="quantity"
                      name="quantity"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      className="p-2 text-black bg-white border border-gray-500 rounded-lg"
                    />
                  </div>
                  <div className="flex flex-col w-[48%]">
                    <label className="mb-2 text-black" htmlFor="height">
                      {t("heightCM")}
                    </label>
                    <input
                      type="number"
                      id="height"
                      name="height"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                      className="p-2 text-black bg-white border border-gray-500 rounded-lg"
                    />
                  </div>
                </div>

                {/* Height, Width, and Length */}
                <div className="flex justify-between ">
                  <div className="flex flex-col w-[48%]">
                    <label className="mb-2 text-black" htmlFor="width">
                      {t("widthCM")}
                    </label>
                    <input
                      type="number"
                      id="width"
                      name="width"
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                      className="p-2 text-black bg-white border border-gray-500 rounded-lg"
                    />
                  </div>
                  <div className="flex flex-col w-[48%]">
                    <label className="mb-2 text-black" htmlFor="length">
                      {t("lengthCM")}
                    </label>
                    <input
                      type="number"
                      id="length"
                      name="length"
                      value={length}
                      onChange={(e) => setLength(e.target.value)}
                      className="p-2 text-black bg-white border border-gray-500 rounded-lg"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="flex flex-col items-center justify-center h-full mt-4">
              <ChevronDoubleDownIcon className="w-6 h-6 my-4 text-black" />
              <CustomButton
                children={t("calculateShippingSection.checkPrice")}
                icon={CalculatorIcon}
                onClick={handleCheckPrice}
              />
            </div>

            {loading && <p>{t("calculateShippingSection.loading")}</p>}
            {error && (
              <p className="text-red-500">
                {t("calculateShippingSection.error")}: {error}
              </p>
            )}
            {errorMessage && (
              <p className="mt-2 text-center text-red-500">{errorMessage}</p>
            )}
          </div>
        </div>
      </div>

      {isOpen && (
        <div>
          <div className="fixed top-0 left-0 w-full h-screen p-4 bg-black bg-opacity-50 z-[99999999999999999]"></div>
          <div
            className="fixed z-[99999999999999999] w-[95%] md:w-[800px] m-auto md:p-4 p-2 bg-yellow-50 border  rounded-md shadow-lg 
            top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black"
            ref={popUpRef}
          >
            <h3 className="text-lg font-bold text-center md:text-2xl">
              {t("calculateShippingSection.companies")}
            </h3>
            <button
              onClick={closeModal}
              className="absolute text-2xl font-bold duration-300 top-2 right-2 hover:text-red-500"
            >
              <XMarkIcon class="h-6 w-6" />
            </button>
            <div className="mt-5">
              <ShippingCompanies
                result={resultText?.data}
                selectedTo={selectedTo}
                selectedFrom={selectedFrom}
                weight={resultText?.finalWeightKg}
              />
              <p className="text-xs text-center md:text-sm">
                {t("externalShippingMessage")}{" "}
                <button
                  onClick={() => navigateWithLang("/contact-us")}
                  className="underline duration-300 hover:text-custom-yellow"
                >
                  {t("contactUs")}
                </button>
              </p>
              <p className="mt-2 text-xs text-center md:text-sm">
                {t("pageShippingMessage")}{" "}
                <button
                  onClick={() => navigateWithLang("/shop-and-ship")}
                  className="underline duration-300 hover:text-custom-yellow"
                >
                  {t("count_shipping")}
                </button>
              </p>
              {/* {t("calculateShippingSection.shipmentCost")}: {resultText} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalcalateShippingSection;
